import { authorizedApi } from './index';

export const notificationsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomGiftCardDesigns: builder.query({
      query: () => '/users/me/custom-designs',
      providesTags: ['CustomGiftCardDesigns'],
    }),
    createCustomGiftCardDesign: builder.mutation({
      query: ({ image, type }) => ({
        url: `/users/me/custom-designs`,
        method: 'POST',
        body: {
          image,
          type,
        },
      }),
      invalidatesTags: ['CustomGiftCardDesigns'],
    }),
    deleteCustomGiftCardDesign: builder.mutation({
      query: ({ imageUrl }) => ({
        url: `/users/me/custom-designs/`,
        method: 'DELETE',
        body: {
          imageUrl,
        },
      }),
      invalidatesTags: ['CustomGiftCardDesigns'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCustomGiftCardDesignsQuery,
  useCreateCustomGiftCardDesignMutation,
  useDeleteCustomGiftCardDesignMutation,
} = notificationsApi;
